import { useNavigate } from "react-router-dom";

import { useT } from "@repo/transifex";
import { Dialog, DialogError } from "~/components";
import { useSendWebEvent } from "~/hooks";
import { useAppContext, useAppDispatch } from "~/providers/app";

import { ScalePrecisionFlow } from "../__app.settings.devices.scales/scale-precision-flow";

/** Re-check the paired scale's precision without pairing it again. */
export const ScalePrecisionPage = () => {
  const {
    hardware: {
      scales: { scale, model, unit, decimals }
    }
  } = useAppContext();
  const dispatch = useAppDispatch();
  const sendWebEvent = useSendWebEvent();
  const navigate = useNavigate();
  const t = useT();

  const back = () => {
    navigate("..");
  };

  if (!scale) {
    return <DialogError backUrl=".." error={t("No scale connected")} />;
  }

  if (!model) {
    return (
      <DialogError
        backUrl=".."
        error={t(
          "This scale was paired before its model was recorded. Pair it again to set its precision."
        )}
      />
    );
  }

  return (
    <Dialog backUrl=".." size="md">
      <div className="flex w-full flex-col p-8">
        <ScalePrecisionFlow
          initialDecimals={decimals}
          model={model}
          onBack={back}
          onConfirm={(confirmed) => {
            dispatch({
              type: "SCALE_PAIRING_SELECTED",
              payload: { model, unit, decimals: confirmed }
            });
            sendWebEvent({
              type: "SCALE_SELECT_REQUEST",
              payload: { scale, model, unit, decimals: confirmed }
            });
          }}
          onDone={back}
          scale={scale}
          unit={unit}
        />
      </div>
    </Dialog>
  );
};
